import en from "./en.json";
import fr from "./fr.json";

const locales = { en, fr }

export default locales;